import React from "react";

export default function EmptyPage({ component: Page }) {
  return <Page />;
}
